import { GetStripePriceOpenDataConfigQuery } from '../../../../graphql/graphql';
import { PlanConfig, Prices, PricingConfig } from '../../types/config';

export default function normalizePricingData(
  products: NonNullable<
    GetStripePriceOpenDataConfigQuery['getStripePriceOpenDataConfig']
  >,
): PricingConfig {
  const pricingConfig: PricingConfig = {} as PricingConfig;

  products.forEach((product) => {
    const productKey = product?.productKey;
    const productName = product?.productName;
    const prices = product?.prices;

    if (!prices || !productKey || !productName) {
      return;
    }

    prices.forEach((price) => {
      const plan = price?.plan;
      const currency = price?.currency;

      if (!plan || !currency) {
        return;
      }

      if (!pricingConfig[plan]) {
        pricingConfig[plan] = {} as PlanConfig;
      }

      const planConfig = pricingConfig[plan];

      if (!planConfig[productKey]) {
        planConfig[productKey] = {
          name: productName,
          prices: {} as Prices,
        };
      }

      const productConfig = planConfig[productKey];

      productConfig.prices[currency] = price;
    });
  });

  return pricingConfig;
}
